<template>
  <div id="app" class="">
    <div class="bg-pink-200 flex flex-row justify-between py-6">
      <div class="fixed left-0 top-8 flex flex-col h-20 justify-center px-3 ">
        <login-button class="flex flex-row justify-between bg-slate-100 py-2 px-6 rounded-full font-semibold text-slate-500 text-lg shadow-lg shadow-slate-300 border-2 border-slate-300 hover:bg-pink-100 hover:shadow-2xl transition-all duration-300 ring-offset-2 focus:ring-2 focus:ring-slate-400"/>
      </div>
      <div class="flex flex-1 justify-center text-center flex-col items-center">
        <img :src="image" class="w-20"/>
        <div class="text-2xl flex justify-center cursor-default"> ToDoU-247 </div> 
      </div>
      
  </div>
    
    
    <nav>
      <div class="m-1 flex flex-row justify-center gap-2">
        <router-link to="/todos">Things To Do</router-link> |
        <router-link to="/done">Accomplishments</router-link>
      </div>
    
    </nav>
    <router-view/>
  </div>
</template>

<script>
import LoginButton from './components/LoginButton.vue';
import { auth } from "@/firebaseConfig";
import image from "./assets/todoulogo.png";

export default {
    components: { LoginButton },
  data() {
    return {
      image: image
    };
  },
  beforeCreate: function() {
    auth.getRedirectResult().then(result=>{
      if (result.user) {
        // We got redirected after a login was successful.
        console.log('result: ', result)
        this.$router.push("/todos")
      }
    }).catch(() => {
      this.$router.push("/loginError")
    })
  },
}
</script>

<style>


body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #8e2e9f;
  background-color: rgb(237, 201, 237);
}



nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #b556c6;
  text-decoration-line: underline;
}





</style>
